import { Injectable } from '@angular/core';

@Injectable()
export class ContactUsService {
  private baseUrl =
    'https://babycheck.imobisoft.uk/api/DontWasteMoney/ContactUs';
  constructor() {}

  async contact(data: any) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.text();
    } catch (error) {
      console.error('Error in contact API:', error);
      throw error;
    }
  }
}
